import React, { useEffect, useRef } from 'react';
import { useMatomo } from '@datapunt/matomo-tracker-react'
import { clsx } from 'clsx';

import RundedrehenMapItemsListTabs from './rundedrehen-map-items-list-tabs';
import RundedrehenMapItemsListSkeleton from './rundedrehen-map-items-list-skeleton';
import RundedrehenMapListItemClubEvent from './rundedrehen-map-list-item-club-event';
import RundedrehenMapListItemPlace from './rundedrehen-map-list-item-place';


'use strict';

function RundedrehenMapItemsList(props) {

  const scrollWrapperRef = useRef();
  const { trackEvent } = useMatomo();

  useEffect(() => {
    scrollWrapperRef.current.scrollTop = 0;
  }, [props.visibleItems]);

  const updateItemType = (itemType) =>  {
    scrollWrapperRef.current.scrollTop = 0;
    props.updateItemType(itemType);
    // track category change in itemlist
    trackEvent({ category: 'itemlist', action: 'change', name: itemType, value: itemType });
  }

  let listContent = ''
  let currentDividerValue = null
  // let is_even = true;

  // get array of all visible items to iterate over and render later
  let listItems = props.mapData.listItems;
  if (props.visibleItems != null && props.visibleItems.length) {
    listItems = [];
    props.mapData.listItems.map((item, index) => {
      for (let i = 0; i < props.visibleItems.length; i++) {
        if (props.visibleItems[i].includes(item.id) && item.label) {
          listItems.push(item);
          break;
        }
      }
    })
  }

  if (props.visibleItems == null || props.visibleItems.length) {
    let counter = 0;

    listContent = listItems.map((item, idx) => {
      let listItemContent = null;
      let divider = null

      if (item.divider != currentDividerValue) {
        // swap bg color indicator
        // for next divider
        // is_even = !is_even;

        divider =
          <React.Fragment>
            <div className={clsx(`
              mx-2 md:mx-3
            `,
              counter > 0 && 'border-b border-primary_d border-dotted',
              counter > 0 && 'mt-4 mb-5',
            )}></div>
            <div className={clsx(`
              sticky top-0 z-10
              px-3 md:px-4
              py-1
              font-bold text-sm
              bg-neutral_d
              text-primary
              flex items-start
            `,
            )}>
              <div className="
                text-tiny md:text-base
              ">
                {item.divider}
              </div>
            </div>
          </React.Fragment>

        // check if date divider is needed, item is visible
        currentDividerValue = item.divider
      }

      // add info about bg color to item
      // item.is_even = is_even;

      // add list item for type
      switch (item.type) {
        case 'club_event':
          listItemContent = <RundedrehenMapListItemClubEvent item={item} />
          break;

        case 'place':
          listItemContent = <RundedrehenMapListItemPlace item={item} />
          break;
      }

      counter++

      return <React.Fragment key={idx}>

        {(divider && props.visibleItems != null && props.visibleItems.includes(item.id)) && (
          <React.Fragment>{divider}</React.Fragment>
        )}

        <div className={clsx(`
          bg-neutral_d
        `,
        (props.visibleItems != null && !props.visibleItems.includes(item.id)) && 'hidden',
        )}
          key={idx}
        >
          <div className={clsx(`
              map-list-item
              px-3 md:px-4
              space-x-2 md:space-x-4
              flex items-center
              transition-opacity relative
              link-wrapper
            `,
            item.type == 'club_event' && 'pt-3 md:pt-2',
            item.type == 'place' && 'py-0',
            props.activeItems.includes(item.id) && 'is-active',
            // item.is_even && 'bg-neutral_l _dark:bg-neutral_d',
            // !item.is_even && '_dark:bg-neutral_dd',
          )}
            onMouseEnter={() => props.setActive([item.id])}
            onMouseLeave={() => props.setActive([])}
          >
            {listItemContent}
          </div>
        </div>
      </React.Fragment>
    })
  }
  else {
    listContent = <div className="
      px-3 md:px-4
      pt-8 md:pt-12
      h-full
      text-base md:text-base+
      text-left font-bold tracking-wide
      text-white
    ">
      <p className="mb-3 md:mb-4">
        Es werden alle Einträge angezeigt, die auch in der Karte sichtbar sind.
      </p>
      <p>
        Wenn die Liste leer ist verändere den Ausschnitt der Karte.
      </p>
    </div>
  }

  return <div className={clsx(`
    map-items-list
    bg-neutral_d rounded-lg overflow-hidden relative z-[200]
    order-2 lg:order-1
    w-full md:w-[100%] lg:w-[40%] 2xl:w-[32rem]
    h-[50%] md:h-[45%] lg:h-[calc(100vh-4rem)] lg:mx-4 lg:my-8
    flex-shrink-0
    flex flex-col
    `,
  )}>

    <RundedrehenMapItemsListTabs
      itemType={props.itemType}
      updateItemType={updateItemType}
    />

    <div className="
      transition-opacity
      opacity-100
      grow
      overflow-y-auto overscroll-auto
    " ref={scrollWrapperRef}>
      {props.loading
        ? <RundedrehenMapItemsListSkeleton image={props.itemType == 'club_event'}/>
        : <React.Fragment>{listContent}</React.Fragment>
      }
      <div className="h-12"></div>
    </div>
  </div>

}

export default RundedrehenMapItemsList;
